import React from "react";
import { isTemplateExisits } from "../../../utils/commonFunctions";
import Config from "../../../config/app.config.json";

const HeaderModalComponent = isTemplateExisits(Config.Header)
  ? require(`./${Config.HeaderModal.template}_HeaderModal`).default
  : null;

interface ModalProps {
  display: boolean;
  onClose: any;
  headerContent: any;
  handleNavigation: any;
  authUser?: any;
  isCheckoutHeader?: boolean;
  primaryHeaders?: Array<any>;
  secondaryHeaders?: Array<any>;
  loginItem: any;
  logoutHandler: any;
  setAuthUser?: any;
  isHomePageHeader?: any;
  isInternationService?: any;
  iscoverageMap?: any;
  isBillCalculator?: any;
  mediaHeaders?: any;
  extraHeaders?: any;
  footerHeaders?: any;
}

export const HeaderModal = (props: ModalProps) => {
  return <HeaderModalComponent {...props} />;
};
